import { createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "navbar-nav" }
const _hoisted_2 = { class: "nav-item" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-bars" }, null, -1)
const _hoisted_4 = [
  _hoisted_3
]
const _hoisted_5 = { class: "navbar-nav ml-auto" }
const _hoisted_6 = { class: "nav-item" }
const _hoisted_7 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-user-edit" }, null, -1)
const _hoisted_8 = { class: "nav-item" }
const _hoisted_9 = /*#__PURE__*/_createElementVNode("i", { class: "fas fa-power-off" }, null, -1)
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_applications_dropdown = _resolveComponent("applications-dropdown")!
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("nav", {
    id: "main-header",
    class: _normalizeClass(["main-header navbar navbar-expand", _ctx.navbarVariant])
  }, [
    _createElementVNode("ul", _hoisted_1, [
      _createElementVNode("li", _hoisted_2, [
        _createElementVNode("button", {
          class: "nav-link",
          role: "button",
          onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.toggleMenuSidebar && _ctx.toggleMenuSidebar(...args)))
        }, _hoisted_4)
      ])
    ]),
    _createElementVNode("ul", _hoisted_5, [
      _createVNode(_component_applications_dropdown),
      _createElementVNode("li", _hoisted_6, [
        _createVNode(_component_router_link, {
          to: "/profile",
          class: "nav-link"
        }, {
          default: _withCtx(() => [
            _hoisted_7
          ]),
          _: 1
        })
      ]),
      _createElementVNode("li", _hoisted_8, [
        _createElementVNode("button", {
          class: "nav-link",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.logout && _ctx.logout(...args)))
        }, _hoisted_10)
      ])
    ])
  ], 2))
}